import {
  DocumentIcon,
  DocumentTextIcon,
  PaperClipIcon,
  PhotoIcon,
  PresentationChartBarIcon,
  TableCellsIcon,
} from '@heroicons/react/24/solid';

export const DOCUMENTS_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,application/pdf,application/msword,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,image/*';

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const getFileIcon = (
  fileType: string,
  fileName?: string,
  iconClass: string = 'size-6 text-slate-500',
) => {
  if (fileType.startsWith('image/')) {
    return <PhotoIcon className={iconClass} />;
  }
  if (fileType.includes('pdf')) {
    return <DocumentTextIcon className={iconClass} />;
  }
  if (
    fileType.includes('spreadsheet') ||
    fileType.includes('excel') ||
    fileName?.match(/\.xlsx?$/i)
  ) {
    return <TableCellsIcon className={iconClass} />;
  }
  if (
    fileType.includes('presentation') ||
    fileType.includes('powerpoint') ||
    fileName?.match(/\.pptx?$/i)
  ) {
    return <PresentationChartBarIcon className={iconClass} />;
  }
  return <DocumentIcon className={iconClass} />;
};

export const getSimpleFileIcon = (
  fileType: string,
  iconClass: string = 'size-6 text-indigo-600',
) => {
  if (fileType?.startsWith('image/')) {
    return <PhotoIcon className={iconClass} aria-hidden="true" />;
  }
  return <PaperClipIcon className={iconClass} aria-hidden="true" />;
};
